class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;

    // Some apps (Fast Bundle) request Dawn's section names ("cart-drawer"), so the drawer is missing from
    // their response: fetch whatever is missing before rendering, otherwise the drawer never opens (2026-09-29).
    const sections = parsedState.sections || {};
    const missing = this.getSectionsToRender().filter((section) => !sections[section.id] && document.getElementById(section.id));
    if (missing.length) {
      return fetch(`${window.location.pathname}?sections=${missing.map((section) => section.section).join(',')}`)
        .then((response) => response.json())
        .then((fetched) => this.renderSections(Object.assign({}, sections, fetched)))
        .catch((e) => console.error(e));
    }

    this.renderSections(sections);
  }

  renderSections(sections) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (element && sections[section.id]) {
        element.innerHTML = this.getSectionInnerHTML(sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
